import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Helmet } from 'react-helmet';
import { Link, useLocation, useParams } from 'react-router-dom';

import recentpostImag1 from './images/blogimage/blog/recent-posts/1.jpg';
import recentpostImag2 from './images/blogimage/blog/recent-posts/2.jpg';
import recentpostImag3 from './images/blogimage/blog/recent-posts/3.jpg';
import recentpostImag4 from './images/blogimage/blog/recent-posts/4.jpg';

import './images/blogimage/css/animate.css';
import './images/blogimage/css/splitting.css';
import './images/blogimage/css/main-LTR-1.css';
import './images/blogimage/css/all.min.css';
import NavbarComponent from './navbar';
import Footer from './footer';

const BlogPage = () => {
  const [posts, setPosts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [recentPosts, setRecentPosts] = useState([]);
  const [tags, setTags] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const postsPerPage = 11;

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const search = queryParams.get("search");
  
  const searchParams = new URLSearchParams(window.location.search);
  const categoryId = searchParams.get('categoryId');
  const TagName = searchParams.get('TagName');
  const SearchName = searchParams.get('SearchName');
  const filterValue = categoryId > 0 ? categoryId : TagName != '' ? TagName : SearchName != '' ? SearchName : 0;

  // const { filterValue } = useParams();
  const filterValueNew = filterValue !== undefined ? parseInt(filterValue) : 0;
   
  const fallbackRecentImages = [recentpostImag1, recentpostImag2, recentpostImag3, recentpostImag4];


   const [isTablet, setIsTablet] = useState(false);
  
    // Function to check window size
    const checkWindowSize = () => {
      if (window.innerWidth <= 1024) {
        setIsTablet(true);
      } else {
        setIsTablet(false);
      }
    };
  
    // Add event listener on component mount
    useEffect(() => {
      checkWindowSize();
      window.addEventListener('resize', checkWindowSize);
  
      return () => {
        window.removeEventListener('resize', checkWindowSize);
      };
    }, []);
  
    useEffect(() => {
      // Scroll to the top of the page on component mount
      window.scrollTo(0, 0);
  }, []);  




  useEffect(() => {
    setCurrentPage(1); // reset to first page
    axios.get('https://fittex.io/jeevanapi/api/apptoodhublog?type=C')
      .then(response => {
        const data = response.data?.data;

        setCategories(Array.isArray(data?.blogCategoryInfo) ? data.blogCategoryInfo : []);
        setTags(Array.isArray(data?.blogTagInfo) ? data.blogTagInfo : []);
        setRecentPosts(Array.isArray(data?.blogInfo) ? data.blogInfo : []);

        if (!filterValue || filterValueNew === 0) {
          setPosts(Array.isArray(data?.blogInfo) ? data.blogInfo : []);
        }
      })
      .catch(error => {
        console.error("Error fetching categories:", error);
      });

    if (!isNaN(filterValueNew) && filterValueNew > 0) {
      axios.get(`https://fittex.io/jeevanapi/api/apptoodhublog?categoryid=${filterValueNew}`)
        .then(response => {
          const PostList = response.data?.data?.blogInfo;
          setPosts(Array.isArray(PostList) ? PostList : []);
        })
        .catch(error => {
          console.error("Error fetching posts by category:", error);
        });
    }

    if (filterValue !== '' && isNaN(filterValueNew)) {
      axios.get(`https://fittex.io/jeevanapi/api/apptoodhublog?FilterText=${filterValue}`)
        .then(response => {
          const PostList = response.data?.data?.blogInfo;
          setPosts(Array.isArray(PostList) ? PostList : []);
        })
        .catch(error => {
          console.error("Error fetching posts by tag:", error);
        });
    }
  }, [filterValue, filterValueNew]);

  const handleSearchChange = (e) => setSearchTerm(e.target.value);

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    const term = searchTerm.trim().toLowerCase();

    if (term !== '') {
      axios.get(`https://fittex.io/jeevanapi/api/apptoodhublog?FilterText=${term}`)
        .then(response => {
          const PostList = response.data?.data?.blogInfo;
          setPosts(Array.isArray(PostList) ? PostList : []);
          setCurrentPage(1); // reset to first page
        })
        .catch(error => {
          console.error("Error fetching posts by tag:", error);
        });
    }
  };

  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = posts.slice(indexOfFirstPost, indexOfLastPost);
  const totalPages = Math.ceil(posts.length / postsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
             <div>
      <NavbarComponent/>
    </div>
      <Helmet>
        <link
          rel="icon"
          href={`${process.env.PUBLIC_URL}/assets/Images/fav-icon/fav-icon.png`}
        />
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/css2?family=Montserrat:wght@700;800;900&family=Nunito:wght@400;500;600;700;800;900&display=swap"
        />
      </Helmet>

      <section className="blog blog-home mega-section">
        <div className="container">
          <div className="row">
            <div className="col-12 col-lg-8">
              <div className="posts-grid row">
                {currentPosts.length > 0 ? (
                  currentPosts.map((post, index) => (
                    <div className={`col-12 ${index !== 0 ? 'col-lg-6' : ''}`} key={index}>
                      <div className="post-box">
                      <Link target='_self' className="read-more" to={`/blogDetails?blogId=${post.blog_Id}`}>
                          <div className="post-img-wraper">
                            <div className="overlay-color"></div>
                            <i className="fas fa-search icon"></i>
                            <img className="post-img" src={post.blog_Banner} alt={post.blog_Header} />
                          </div>
                        </Link>
                        <div className="post-summary">
                          <div className="post-info">
                            <a className="post-cat" href="#"><i className="fas fa-list-alt icon"></i>{post.blog_Category}</a>
                            <span className="post-date"><i className="fas fa-history icon"></i>{post.blog_Date}</span>
                            <a className="post-author" href="#"><i className="fas fa-user icon"></i>{post.author}</a>
                            <a className="post-cat" href="#"><i className="fas fa-history icon"></i>{post.read_Time}</a>
                          </div>
                          <div className="post-text">
                          <Link target='_self' className="read-more" to={`/blogDetails?blogId=${post.blog_Id}`}>
                              <h2 className="post-title">{post.blog_Header}</h2>
                            </Link>
                            <div key={post.id}>
                              <p className="post-excerpt">{post.title}</p>
                              <Link target='_self' className="read-more" to={`/blogDetails?blogId=${post.blog_Id}`}>
                                Read more<i className="fas fa-arrow-right icon"></i>
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <p>No posts found.</p>
                )}
              </div>
            </div>

            {/* Sidebar */}
            <div className="col-12 col-lg-4">
              <div className="blog-sidebar">

                {/* Search */}
                <div className="search sidebar-box">
                  <form className="search-form" onSubmit={handleSearchSubmit}>
                    <input
                      className="search-input"
                      type="search"
                      placeholder="Search Posts..."
                      value={searchTerm}
                      onChange={handleSearchChange}
                    />
                    <button className="search-btn" type="submit"><i className="fas fa-search icon"></i></button>
                  </form>
                </div>

                {/* Categories */}
                <div className="cats sidebar-box">
                <h6 className="sidebar-box-title flex items-center justify-between">
  <span><i className="fas fa-list-alt icon"></i> Categories:</span>
 <Link to="/blogpage"><span className="text-right spanalltxt">All</span></Link>
</h6>
                  <ul className="sidebar-list cats-list">
                    {categories.length > 0 ? categories.map((cat, idx) => (
                      <li className="cat-item" key={idx} style={{ cursor: "pointer" }}>
                        <span className="cat-link"><Link className="post-link" to={`/blogpage?categoryId=${cat.blog_CategoryId}`}>{cat.blog_Category}</Link></span>
                        <span className="cat-count"><Link className="cat-count" to={`/blogpage?categoryId=${cat.blog_CategoryId}`}>{cat.blog_CategoryCnt}</Link></span>
                      </li>
                    )) : <li>No categories available.</li>}
                  </ul>
                </div>

                {/* Recent Posts */}
                <div className="recent-posts sidebar-box">
                  <h6 className="sidebar-box-title"><i className="fas fa-history icon"></i>Recent Posts:</h6>
                  <ul className="sidebar-list r-posts-list">
                    {recentPosts.slice(0, 5).map((post, idx) => (
                      <li className="r-post-item" key={idx}>
                            <Link to={`/blogDetails?blogId=${post.blog_Id}`} className="r-post-link">
                          <div className="r-post-img-wraper">
                            <img className="r-post-img" src={post.blog_Banner} alt={post.blog_Header} />
                          </div>
                          <div className="content recentcontent">
                            <h6 className="r-post-title">{post.blog_Header}</h6>
                            <span className="r-post-date">{post.blog_Date}</span>
                          </div>
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>

                {/* Tags */}
                <div className="tags sidebar-box">
                  <h6 className="sidebar-box-title"><i className="fas fa-tags icon"></i>Tags:</h6>
                  <ul className="sidebar-list tags-list">
                    {tags.length > 0 ? tags.map((tag, idx) => {
                      const isActive = tag.blog_Tag === filterValue;
                      return (
                        <li className={`tag-item ${isActive ? 'active-tag' : ''}`} key={idx}>
                          <Link target="_self" className={`tag-link ${isActive ? 'active-tag-link' : ''}`} to={`/blogpage?TagName=${encodeURIComponent(tag.blog_Tag)}`}>
                            {tag.blog_Tag}
                          </Link>
                        </li>
                      );
                    }) : <li>No tags available.</li>}
                  </ul>
                </div>

                {/* Social */}
                <div className="follow-us sidebar-box">
                  <h6 className="sidebar-box-title"><i className="fas fa-heart icon"></i>Follow Us On:</h6>
                  <div className="sc-wraper dir-row sc-size-32">
                  <ul className="sc-list">
  <li className="sc-item">
    <a className="sc-link" href="https://www.facebook.com/fittex.io" target="_blank" rel="noopener noreferrer">
      <i className="fab fa-facebook-f sc-icon"></i>
    </a>
  </li>
  <li className="sc-item">
    <a className="sc-link" href="https://www.youtube.com/@Fittex_io" target="_blank" rel="noopener noreferrer">
      <i className="fab fa-youtube sc-icon"></i>
    </a>
  </li>
  <li className="sc-item">
    <a className="sc-link" href="https://www.instagram.com/fittex.io/" target="_blank" rel="noopener noreferrer">
      <i className="fab fa-instagram sc-icon"></i>
    </a>
  </li>
  <li className="sc-item">
    <a className="sc-link" href="https://www.linkedin.com/company/fittex-web/posts/?feedView=all" target="_blank" rel="noopener noreferrer">
      <i className="fab fa-linkedin sc-icon"></i>
    </a>
  </li>
</ul>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Pagination */}
      <div className="col-12 blog">
        <nav className="posts-pagination">
          <ul className="pagination justify-content-center">
            <li className={`posts-page-item ${currentPage === 1 ? 'deactive-posts-page-item' : ''}`}>
              <a className="posts-page-link" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
                <i className="fas fa-arrow-left icon"></i>
              </a>
            </li>

            {Array.from({ length: totalPages }, (_, i) => (
              <li key={i} className={`posts-page-item ${currentPage === i + 1 ? 'active' : ''}`}>
                <a className="posts-page-link" onClick={() => handlePageChange(i + 1)}>
                  {i + 1}
                </a>
              </li>
            ))}

            <li className={`posts-page-item ${currentPage === totalPages ? 'deactive-posts-page-item' : ''}`}>
              <a className="posts-page-link" onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>
                <i className="fas fa-arrow-right icon"></i>
              </a>
            </li>
          </ul>
        </nav>
      </div>

      <Footer/>
    </>
  );
};

export default BlogPage;